// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b5e42d0f","186":"22c37662","344":"e3be1cbe","372":"f88656d1","738":"e21d7d9a","787":"d7664246","841":"72026891","856":"95b4fa17","858":"0a982c33"}[chunkId] + ".chunk.js";
};